import { useState } from 'react';

import { IThumbnail, IThumbnailId } from '../../types';
import { ResponsiveDrawer } from './ResponsiveDrawer';
import { ThumbnailsList } from './ThumbnailsList';
import { DRAWER, HIDE_TEXT_DRAWER_WIDTH } from './config';

interface CaptureThumbnailsProps {
  thumbnails: IThumbnail[];
  selectedThumbnailId: IThumbnailId | null;
  pieceId: number;
  pieceDocumentId: number | null;
  onChangeThumbnails: (thumbnails: IThumbnail[]) => void;
  onClickThumbnail: (thumbnail: IThumbnailId) => any;
}

export const CaptureThumbnails = ({
  thumbnails,
  selectedThumbnailId,
  pieceId,
  pieceDocumentId,
  onChangeThumbnails,
  onClickThumbnail,
}: CaptureThumbnailsProps) => {
  const [drawerWidth, setDrawerWidth] = useState(DRAWER.default);

  return (
    <ResponsiveDrawer
      drawerWidth={drawerWidth}
      onChangeDrawerWidth={setDrawerWidth}
      content={
        <ThumbnailsList
          thumbnails={thumbnails}
          onChangeThumbnails={onChangeThumbnails}
          active={selectedThumbnailId}
          pieceId={pieceId}
          pieceDocumentId={pieceDocumentId}
          hideThumbnails={!(drawerWidth > DRAWER.minWidth)}
          showDndInfo={thumbnails.length > 1 && drawerWidth >= HIDE_TEXT_DRAWER_WIDTH}
          showClickThumbnailInfo={thumbnails.length > 0 && drawerWidth >= HIDE_TEXT_DRAWER_WIDTH}
          handleClickThumbnail={onClickThumbnail}
        />
      }
    />
  );
};
